import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
import TextLogicalReasoningQuestion from "@/components/subject/TextLogicalReasoning/TextLogicalReasoningQuestion.vue";
import TextAnalogyQuestion from "@/components/subject/TextLogicalReasoning/TextAnalogyQuestion.vue";
export default {
  name: "TextLogicalReasoningRender",
  components: {
    TextAnalogyQuestion,
    TextLogicalReasoningQuestion,
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      answer: null
    };
  },
  computed: {
    isAnalogy() {
      return this.data?.question?.contentMode === 'VERBAL_ANALOGY';
    },
    correctAnswer() {
      return this.data?.rightAnswer || this.data?.question?.rightAnswer || this.review?.rightAnswer || '';
    }
  },
  methods: {
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l[0] : null);
    },
    onAnalogyChoose(answer) {
      this.$emit('answer', answer);
    },
    init() {
      this.answer = null;
    }
  },
  mounted() {
    this.init();
  }
};